import { defer } from 'lodash-es';
import router, { getRoot } from 'core/router';
import store from 'store';
import PanelPage from 'navigation/pages/PanelPage';
import promise from 'helpers/promise';
import { frameToMs } from 'helpers/easings';
import MainPageManager from './MainPageManager';
import CustomPageManager, { extractInfoFromXhr } from './CustomPageManager';
class VirtualPageManager extends CustomPageManager {
    store;
    constructor(store, ...args) {
        super(...args);
        this.main = false;
        this.store = store;
    }
    updatePageLinks(el) {
        const links = Array.from(el.querySelectorAll('[data-navigo]:not([data-navigo="parent"]), .data-navigo'));
        links.forEach(link => {
            if (link.hasListenerAttached)
                return;
            link.addEventListener('click', this.onLinkClicked);
            link.hasListenerAttached = true;
        });
    }
    // Inspired by navigo
    onLinkClicked = (event) => {
        const link = event.currentTarget;
        if (!link)
            return;
        if ((event.ctrlKey || event.metaKey) && link.tagName?.toLowerCase() === 'a')
            return false;
        event.preventDefault();
        event.stopPropagation();
        // event.stopImmediatePropagation()
        const location = router.getLinkPath(link);
        this.navigateTo(location.replace(/\/+$/, '').replace(/^\/+/, '/'));
    };
    initializeRoutes() {
        defer(() => {
            this.store.listenAndStart((page) => {
                if (this.disabled)
                    return;
                this.onRouteUpdate(page);
            });
            const defaultRoute = this.container && this.container.getAttribute('default-route');
            if (!this.currentPage && this.extractPage(this.container)) {
                // if (!defaultRoute && getHistory()?.length > 1) defaultRoute = store.path.get()
                this.store.value = defaultRoute || store.path.get();
                if (!this.store.value)
                    return;
                return this.initializePage();
            }
            if (!this.store.value && !this.currentPage)
                if (defaultRoute)
                    this.navigateTo(defaultRoute);
        });
    }
    forceRouteUpdate(...args) {
        const [pathName] = args;
        this.store.value = pathName;
        return this.pageLoaded(...args);
    }
    cancelTransition() {
        this.store.set(null);
        this.state.loading = false;
    }
    onRouteUpdate(pathName, requestOptions = {}) {
        if (!pathName && pathName !== '') {
            if (this.currentPage) {
                this.previousPage = this.currentPage;
                this.state.next = undefined;
                this.currentPage = undefined;
                this.hidePage();
            }
            return false;
        }
        return super.onRouteUpdate(pathName, requestOptions);
    }
    async removePage() {
        if (this.defaultPageClass === PanelPage)
            await promise.wait(frameToMs(8));
        if (!this.previousPage)
            return;
        if (!this.currentPage)
            this.state.previous = null;
        return super.removePage();
    }
    load(pathName, options) {
        if (!~pathName.indexOf(getRoot()))
            pathName = getRoot() + pathName;
        return super.load(pathName, options);
    }
    rewriteRoute(pathName, overwrite = true) {
        if (~pathName.indexOf(getRoot()))
            pathName = pathName.replace(getRoot(), '');
        if (overwrite) {
            this.store.value = pathName;
        }
        else {
            this.disabled = true;
            this.store.set(pathName);
            this.disabled = false;
        }
    }
    createPage(el, PageClass) {
        const page = MainPageManager.prototype.createPage.call(this, el, PageClass);
        this.updatePageLinks(page.el);
        return page;
    }
    navigateTo(pathName) {
        this.store.set(pathName);
    }
    refresh() {
        const pathName = this.store.value;
        this.store.value = '';
        this.store.set(pathName);
    }
    async pageLoaded(...args) {
        const xhr = args[1];
        const page = xhr.response;
        if (!page || !page.body || !page.body.innerHTML) {
            extractInfoFromXhr(xhr);
            document.documentElement.classList.remove('loading');
            this.state.loading = false;
            this.state.transitioning = false;
            this.store.set(null);
            return false;
        }
        return super.pageLoaded(...args);
    }
    flush() {
        this.store.unlisten();
    }
}
export default VirtualPageManager;
